import { ref } from 'vue'
import { useDialogDismissGuard } from '@/composables/useDialogDismissGuard'

interface FormCloseGuardOptions {
  hasUnsavedChanges: () => boolean
  forceClose: () => void
  enabled?: () => boolean
}

/** Запрос закрытия формы с подтверждением при несохранённых изменениях. */
export function useFormCloseGuard(options: FormCloseGuardOptions) {
  const showUnsavedChangesDialog = ref(false)

  const requestClose = () => {
    if (options.enabled?.() === false || !options.hasUnsavedChanges()) {
      options.forceClose()
      return
    }
    showUnsavedChangesDialog.value = true
  }

  const handleCloseConfirm = (confirmed: boolean) => {
    showUnsavedChangesDialog.value = false
    if (confirmed) {
      options.forceClose()
    }
  }

  const onDialogDismissAttempt = useDialogDismissGuard(requestClose)

  const onDialogUpdate = (value: boolean) => {
    if (value) {
      return
    }
    requestClose()
  }

  return {
    showUnsavedChangesDialog,
    requestClose,
    handleCloseConfirm,
    onDialogDismissAttempt,
    onDialogUpdate,
  }
}
